import request from '@/utils/requset'

// 实验报告
export function report(data) {
  return request({
    url: `h5/course/report`,
    method: 'post',
    data: data
  })
}

// 实验记录
export function expRecord(data) {
  return request({
    url: `h5/course/record`,
    method: 'post',
    data: data
  })
}

// 获取实验记录
export function recordInfo(id) {
  return request({
    url: `h5/course/get_record`,
    method: 'get',
    params: { course_id: id}
  })
} 